import * as React from 'react';
import { Box, Typography, Button, Stack, useTheme } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import ImageUpload from '../../../components/ImageUpload';
import CustomDropDown from '../../../components/CustomDropDown';
import { createAmtcEmpServ } from '../../../services/amtc-service';



const userTypeArr = [
  { value: "sourcing", label: "Sourcing" },
  { value: "store", label: "Store" },
  { value: "accounts", label: "Accounts" }];


function CreateAmtcEmpPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { setLoadingScreen } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const [img, setImg] = useState({ fileKey: "", fileUrl: "" });
  const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }
  const [selection, setSelection] = useState({ userType: userTypeArr[0].value });





  function handleImgRemove() {
    setImg({ fileKey: "", fileUrl: "" })
  };

  function handleOnUpload({ fileKey, fileUrl }) {
    setImg({ fileKey, fileUrl })
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const payload = {
        username: inputObject.username,
        userType: selection.userType,
        empId: inputObject.empId,
        fName: inputObject.fName,
        lName: inputObject.lName,
        phoneNo: inputObject.phoneNo,
        profileImg: img.fileKey,
      }
     
      const { message } = await createAmtcEmpServ(payload);
      notify("success", message);
      navigate(route.aAmtcEmpList, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};

    if (!values.fName)
      errors.fName = "Name is required!";

    if (!values.username)
      errors.username = "Email is required!";

    if (!values.userType)
      errors.userType = "Employee Role is required!";

    return errors;
  };

  function handleDDChange(e) {
    const { name, value } = e.target;
   
    setSelection((e) => { return { ...e, [name]: value } });
  }


  async function handleCancel() {
    navigate(route.aAmtcEmpList, { replace: true })
  }


  return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
    <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
      <Stack width={"20%"}>
        <BackButton />
      </Stack>
      <Stack width={"60%"} alignItems={"center"}>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create AMTC Employee </Typography>
      </Stack>
      <Stack width={"20%"} />
    </Stack>
    <BgBoxOld height={"93%"} py={1}>
      <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo name="fName" errMsg={formErrors.fName} title="First Name *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="lName" title="Last Name" {...txtFieldSx} />
          <LabelTxtFieldInfo name="username" errMsg={formErrors.username} title="Email ID (Username) *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="phoneNo" title="Contact No" {...txtFieldSx} />
        </Stack>
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo name="empId" title="Employee ID" {...txtFieldSx} />
          <CustomDropDown name="userType" errMsg={formErrors.userType} title={"Employee Role *"} {...txtFieldSx} handleDDChange={handleDDChange} ddArr={userTypeArr} defaultValue={userTypeArr[0].value} />
        </Stack>
        <ImageUpload currentImage={img?.fileUrl} onUpload={handleOnUpload} onRemove={handleImgRemove} boxTitle={"Employee Profile"} btnName={"Upload Image"} />
        <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
          <Button variant="outlined" onClick={handleCancel} sx={{
            fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
            color: theme.palette.custom.btn, mr: 2,
          }}>CANCEL</Button>
          <Button variant="contained" type="submit"
            sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>CREATE</Button>
        </Box>
      </Stack>
    </BgBoxOld>
  </form>
  );
}

export default CreateAmtcEmpPage;